// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"98f8b588","453":"1cfc6aac","934":"7c36a032"}[chunkId] + ".chunk.js";
};